<template>
  <AgrLogin
    :loading="loading"
    :error="error"
    :app-version="appVersion"
    @login="loginSso({routeHome:{name:'main'}})"
  >
    <template v-slot:title>
      <div class="align-center">
        <img
          src="../assets/logo_culturial.png"
          class="logo"
        >
        <p class="text-h4 pt-2 mx-6 assistant">
          L’assistant de pilotage de vos cultures.
        </p>
      </div>
    </template>
    <template v-slot:logo>
      <img
        src="../assets/logo-minimal.png"
        class="logo mb-10"
      >
    </template>
  </AgrLogin>
</template>

<script>
import { mapGetters } from 'vuex'
import { AgrLogin } from '@agrial/ui'
import { loginMixin } from '@agrial/vue-plugin-security'

export default {
  name: 'Login',
  components: { AgrLogin },
  mixins: [loginMixin],
  computed: {
    ...mapGetters({
      appVersion: 'app/version'
    })
  }
}
</script>
<style lang="scss" scoped>
.logo {
  width: 17rem;
}
.assistant{
  color: #DABC00
}
</style>